<script lang="ts">
    export let images_list    : { name: string; data: string }[];
    export let require_images : {[key: string]: boolean};

    let files : FileList;

    function doUpload() {
        reset_images_upload();
        for (let file of files) {
            let reader : FileReader = new FileReader();
            reader.onload = function(e) {
                // 選択されたファイルがBase64エンコードできていなければ中断
                if (typeof e.target.result !== 'string') {
                    return;
                }

                // 必要画像リストにあるかを確認
                let texture_id = file.name.substring(0, file.name.lastIndexOf('.'));
                if (texture_id in require_images) {
                    require_images[texture_id] = true;
                    images_list = [...images_list, {name: file.name, data: e.target.result}];
                }
            };
            reader.readAsDataURL(file);
        }
    }

    
    /** 選択ファイルに関わるデータを初期化する
     * 
     */
     function reset_images_upload() {
        images_list = [];
        Object.keys(require_images).forEach(key => {
            require_images[key] = false;
        });
    }
</script>

<div>
    <p>髪型に使用しているテクスチャ画像を選択してください。(xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx.png)</p>
    <input type="file" accept="image/png" multiple bind:files on:change={doUpload} />
</div>
